import React, { useEffect, useState } from "react";
import TextInput from "../common/textInput/TextInput";
import GridContainer from "../common/grid/GridContainer";
import GridItem from "../common/grid/GridItem";
import ButtonLayout from "../common/button/ButtonLayout";
import DataTable from "../common/dataTable/DataTable";
import { useMediaQuery, useTheme } from "@mui/material";
import DataList from "../common/dataList/DataList";
import SimpleSnackbar from "../common/snackbar/Snackbar";
import SimpleBackdrop from "../common/backdrop/Backdrop";
import { validateFields } from "../../utils/helpers/Validation";
import {
  createPart,
  deletePart,
  getPartsList,
  updatePart,
} from "../../services/partServices";

const MaintenanceForm = (props) => {
  const [MaintenenceFormData, setMaintenenceFormData] = useState(props.data);
  const [partsRows, setPartsRows] = useState(props.partsRows);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [updateRecord, setUpdateRecord] = useState(null);
  const [selected, setSelected] = React.useState({ index: null, record: null });
  const [enableBtn, setEnableBtn] = React.useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [apiError, setApiError] = useState(
    props.apiError || { val: false, messages: "" }
  );
  const [errorMessages, setErrorMessages] = useState(null);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [loader, setLoader] = useState(props.loader || false);
  const [message, setMessage] = useState("");
  const [searchedData, setSearchedData] = useState("");

  const getSourceFromTitle = (title) => {
    switch (title) {
      case "partNumber":
        return "parts-maintenance";
      default:
        return "other";
    }
  };
  const title =
    MaintenenceFormData &&
    Array.isArray(MaintenenceFormData) &&
    MaintenenceFormData?.length > 0
      ? props.panelId === "panel3-header" && MaintenenceFormData[0]?.id
      : "";
  const source = getSourceFromTitle(title);
 
  const partsList = async () => {
    setLoader(true);
    try {
      const response = await getPartsList();
      setPartsRows(response?.parts?.reverse());
      setLoader(false);
    } catch (error) {
      setApiError((val) => ({ ...val, val: true, message: error.message }));
      setLoader(false);
    }
  };

  const handleCreate = async () => {
    const errors = validateFields(selectedRecord, MaintenenceFormData);

    if (Object.keys(errors).length > 0) {
      setErrorMessages(errors);
      return;
    }
    try {
      setLoader(true);
      const response =
        source === "parts-maintenance" &&
        (await createPart({
          partNumber: selectedRecord.partNumber,
          remarks: selectedRecord.remarks,
        }));

      source === "parts-maintenance" && (await partsList());

      if (source === "parts-maintenance") {
        setSelectedRecord({ id: "", label: "", value: "" });
      }

      setMessage(response?.message);
      setTimeout(() => {
        setMessage("");
      }, 3000);
      setLoader(false);
    } catch (error) {
      setApiError((val) => ({ ...val, val: true, message: error.message }));
      setLoader(false);
    }
  };
  const handleUpdate = async () => {
    const errors = validateFields(selectedRecord, MaintenenceFormData);

    if (Object.keys(errors).length > 0) {
      setErrorMessages(errors);
      return;
    } else {
      if (!updateRecord) return;
      setLoader(true);
      const recordForPartId = partsRows?.find(
        (record) => record.partNumber === updateRecord?.partNumber
      );
      try {
        const response =
          source === "parts-maintenance" &&
          (await updatePart({
            id: recordForPartId?.id,
            partNumber: selectedRecord.partNumber,
            remarks: selectedRecord.remarks,
          }));

        source === "parts-maintenance" && (await partsList());

        if (source === "parts-maintenance") {
          setSelectedRecord({ id: "", label: "", value: "" });
        }

        setMessage(response?.message);
        setTimeout(() => {
          setMessage("");
        }, 3000);
        setLoader(false);
        setIsCheckboxChecked(false);
      } catch (error) {
        setApiError((val) => ({ ...val, val: true, message: error.message }));
        setLoader(false);
      }
      setEnableBtn(false);
      setSelected("");
    }
  };

  const handleDelete = async () => {
    if (!updateRecord) return;
    setLoader(true);
    const recordForPartId = partsRows?.find(
      (record) => record.partNumber === updateRecord?.partNumber
    );
    try {
      const response =
        source === "parts-maintenance" &&
        (await deletePart(recordForPartId?.id));
      source === "parts-maintenance" && (await partsList());
      if (source === "parts-maintenance") {
        setSelectedRecord({ id: "", label: "", value: "" });
      }
      setLoader(false);
      setMessage(response?.message);
      setTimeout(() => {
        setMessage("");
      }, 3000);
      setIsCheckboxChecked(false);
    } catch (error) {
      setApiError((val) => ({ ...val, val: true, message: error?.message }));
      setLoader(false);
    }
  };

  useEffect(() => {
    setPartsRows(props?.partsRows);
    setLoader(props?.loader);
    setApiError(props?.apiError);
    setSearchedData("");
  }, [props]);

  useEffect(() => {
    setMaintenenceFormData(props.data);
    setSelectedRecord({ id: "", label: "", value: "" });
  }, [props.data]);

  const handleAddClick = () => {
    handleCreate();
  };

  const handleEditClick = () => {
    handleUpdate();
  };

  const handleDeleteClick = (id) => {
    handleDelete();
    setEnableBtn(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedRecord((prevRecord) => ({
      ...prevRecord,
      [name]: value,
    }));
    setErrorMessages((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") {
        delete newErrors[name];
      }
      return newErrors;
    });
  };
  const handleChange = (e) => {
    setSearchedData(e.target.value);
  };
  const handleChecked = (e, record, index) => {
    if (selected && selected.index === index) {
      setSelected({ index: null, record: null });
      setSelectedRecord({ id: "", label: "", value: "" });
      setUpdateRecord({ id: "", label: "", value: "" });
      setEnableBtn(false);
      setIsCheckboxChecked(false);
    } else {
      setSelected({ index, record });
      setSelectedRecord({ ...record });
      setUpdateRecord({ ...record });
      setEnableBtn(true);
      setIsCheckboxChecked(true);
      setErrorMessages({});
    }
  };
  return (
    <>
      <SimpleBackdrop open={loader} />
      <GridContainer
        spacing={2}
        sx={{
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        <GridItem
          xs={12}
          sm={4}
          lg={4}
          md={4}
          xl={4}
          sx={{ marginTop: "12px" }}
        >
          {MaintenenceFormData &&
            Array.isArray(MaintenenceFormData) &&
            MaintenenceFormData.map((data, index) => (
              <div key={index} style={{ marginBottom: "10px" }}>
                <TextInput
                  key={index}
                  label={data.label}
                  name={data.id}
                  value={
                    selectedRecord && selectedRecord[data.id]
                      ? selectedRecord[data.id] || ""
                      : ""
                  }
                  testid="input"
                  datatestid={data.id}
                  onChange={handleInputChange}
                  required={true}
                  multiline={data?.multiline}
                  rows={data?.rows}
                />
                {errorMessages && errorMessages[data.id] && (
                  <div style={{ color: "red", marginTop: "4px" }}>
                    {errorMessages[data.id]}
                  </div>
                )}
              </div>
            ))}
          {message && (
            <div style={{ marginBottom: "1px", color: "green" }}>{message}</div>
          )}
          <div
            className="padding-sm-t"
            style={{ display: "flex", gap: "10px", marginRight: "10px" }}
          >
            <ButtonLayout
              color="primary"
              label="Save"
              onClickBtn={handleAddClick}
              testid="add"
              disabled={enableBtn}
            />
            <ButtonLayout
              color="primary"
              label="Update"
              onClickBtn={handleEditClick}
              testid="edit"
              disabled={!isCheckboxChecked}
            />
            <ButtonLayout
              color="primary"
              label="Delete"
              testid="delete"
              onClickBtn={handleDeleteClick}
              disabled={!isCheckboxChecked}
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={8} lg={8} md={8} xl={8}>
          <TextInput
            sx={
              isMobile
                ? { width: "100%", marginBottom: "2%" }
                : { width: "50%", marginLeft: "48%", marginBottom: "2%" }
            }
            label="Search..."
            testid="searchInput"
            onChange={handleChange}
            value={searchedData}
          />
          {partsRows &&
            partsRows.length > 0 &&
            (isMobile ? (
              <DataList
                source={source}
                data={MaintenenceFormData}
                rows={source === "parts-maintenance" && partsRows}
                onEdit={handleEditClick}
                testid="datalist"
                onDelete={handleDeleteClick}
                handleChecked={handleChecked}
                selected={selected}
                searchedData={searchedData}
              />
            ) : (
              <DataTable
                source={source}
                rows={source === "parts-maintenance" && partsRows}
                data={MaintenenceFormData}
                testid="datatable"
                onEdit={handleEditClick}
                onDelete={handleDeleteClick}
                notShow={true}
                handleChecked={handleChecked}
                selected={selected}
                searchedData={searchedData}
              />
            ))}
        </GridItem>
      </GridContainer>
      <SimpleSnackbar apiError={apiError} />
    </>
  );
};

export default MaintenanceForm;
